import { Switch } from '@material-ui/core';
import { styled } from '@mui/material';

const MySwitch = styled(Switch)`
  filter: drop-shadow(0px 1px 2px rgba(145, 158, 171, 0.24));
  overflow: hidden;
`;

export default MySwitch;
